export function addModulePlacement(
  anchor: { right: number; bottom: number },
  panel: { width: number; height: number },
  viewport: { width: number; height: number },
): { left: number; top: number; maxHeight: number } {
  const margin = 12;
  const maxHeight = Math.max(0, viewport.height - margin * 2);
  return {
    left: Math.max(margin, Math.min(anchor.right - panel.width, viewport.width - panel.width - margin)),
    top: Math.max(
      margin,
      Math.min(anchor.bottom + 4, viewport.height - Math.min(panel.height, maxHeight) - margin),
    ),
    maxHeight,
  };
}
